import axios, { AxiosResponse } from 'axios'

import { ShowTimeId, ShowTimeRead, ShowTimeWrite } from '@generated/types'

const BASE_URL = '/api/showtime'

export default {
  async fetchAll(): Promise<AxiosResponse<ShowTimeRead[]>> {
    return axios.get(`${BASE_URL}/`)
  },

  async create(data: ShowTimeWrite): Promise<AxiosResponse<ShowTimeRead>> {
    return axios.post(`${BASE_URL}/`, data)
  },

  async update(data: ShowTimeWrite): Promise<AxiosResponse<ShowTimeRead>> {
    // Ensure data.id exists before using it in the URL
    if (data.id === undefined || data.id === null) {
      return Promise.reject(new Error('Show time ID is required for update.'))
    }
    return axios.put(`${BASE_URL}/${data.id}/`, data)
  },

  async updateAll(data: ShowTimeWrite[]): Promise<AxiosResponse<ShowTimeRead[]>> {
    return axios.put(`${BASE_URL}/all/`, data)
  },

  async delete(id: ShowTimeId): Promise<AxiosResponse> {
    // Changed id type from number
    return axios.delete(`${BASE_URL}/${id}/`)
  },
}
